<ng-container *ngIf="readonly | equals:false; else readonlyContent">
    <input #input type="text" [readonly]="readonly" [ngModel]="value | currency:'EUR':'':null:'nl'" [ngModelOptions]="{updateOn:'blur'}"
        (ngModelChange)="_handleModelChange($event)" (mousedown)="_handleClick($event)" (focus)="_handleFocus($event)" (blur)="_handleBlur($event)" (keydown)="_handleKeydown($event)" (change)="_purgeEvent($event)" (copy)="_purgeEvent($event)" (cut)="_purgeEvent($event)" (paste)="_purgeEvent($event)"
    />
</ng-container>
<ng-template #readonlyContent>
    <div class="content">{{ value | currency:'EUR':'':null:'nl' }}</div>
</ng-template>